<template>
  <v-app>
<!--    <v-overlay :value="" absolute z-index="999999">-->
<!--      <app-centre-loader label="Connection lost.<br/>Attempting to reconnect"></app-centre-loader>-->
<!--    </v-overlay>-->
    <v-main style="width: 100vw; height: 100vh; overflow-x: hidden; overflow-y: auto; position: relative">
      <template v-if="!$store.state.employeeDashboard.show">
        <app-snack></app-snack>
        <v-navigation-drawer
          permanent
          v-if="loggedIn && !startingUp"
          mini-variant-width="54"
          v-model="drawer"
          app
          :mini-variant.sync="mini"
          :expand-on-hover="smallBar"
          class="d-flex flex-column fill-height of-y full-nav"
        >

          <v-scroll-x-transition :hide-on-leave="true">
            <div class="d-flex align-center justify-center my-4" v-if="!mini">
              <img alt="logo" :src="$vuetify.theme.dark ? 'images/watch_dark-01.svg' : 'images/watch_light-01.svg'" height="30" class="pr-2"/>
              <img alt="logo" :src="$vuetify.theme.dark ? 'images/text_only_no_subtext_white-01.svg' : 'images/text_only_no_subtext_light-01.svg'" height="24"/>
            </div>
          </v-scroll-x-transition>

          <v-scroll-x-transition :hide-on-leave="true">
            <div class="d-flex align-center justify-center my-4" v-if="mini">
              <img alt="logo" :src="$vuetify.theme.dark ? 'images/watch_dark-01.svg' : 'images/watch_light-01.svg'" height="30"/>
            </div>
          </v-scroll-x-transition>

          <v-list
            dense
            v-model="curPage"
            class="flex-grow-1"
          >
            <app-user-options v-if="!!user"></app-user-options>
            <!--User-->
            <v-list-item @click="$store.state.userOptionsShown = true">
              <v-list-item-avatar>
                <v-btn icon outlined color="white"><v-icon>mdi-account</v-icon></v-btn>
              </v-list-item-avatar>
              <v-list-item-title>
                <div class="">
                  {{ user.name }}
                </div>
              </v-list-item-title>
              <v-list-item-action>

                <v-tooltip right>
                  <template v-slot:activator="{on}">
                    <v-btn
                      icon
                      @click.stop="mini = !mini"
                      color="primary"
                      small
                      v-on="on"
                    >
                      <v-icon>
                        mdi-chevron-left
                      </v-icon>
                    </v-btn>
                  </template>
                  Hide App Bar
                </v-tooltip>
              </v-list-item-action>
            </v-list-item>

            <div @click="viewSites.length >= 7 ? showSiteSelectDlg = true : null">
              <v-overflow-btn
                :items="viewSites"
                :value="site._id"
                item-text="name"
                item-value="_id"
                label="Overflow Btn - Dense"
                dense
                :hide-details="true"
                :readonly="viewSites.length >= 7"
                @change="switchSiteRun"
              ></v-overflow-btn>
            </div>
            
            <v-list-item>
              <v-list-item-avatar>
                <v-btn icon color="white"><v-icon>mdi-server</v-icon></v-btn>
              </v-list-item-avatar>
              <v-list-item-title>
                <template v-if="!socketConnected && loggedIn">Socket connecting...</template>
                <template v-else>Server connected</template>
              </v-list-item-title>
            </v-list-item>


            <v-list-item-group
              :value="curPage"
              @change="gotoPage"
              color="primary"
            >
              <!--Dashboard-->
              <v-list-item
                v-if="access.statistics"
                active-color="primary"
                value="dashboard"
              >
                <v-list-item-avatar left>
                  <v-icon>mdi-monitor-dashboard</v-icon>
                </v-list-item-avatar>
                <v-list-item-title>Dashboard</v-list-item-title>
              </v-list-item>
              <!--Users-->
              <v-list-item
                v-if="access.users"
                active-color="primary"
                value="users"
              >
                <v-list-item-avatar left>
                  <v-icon>mdi-badge-account</v-icon>
                </v-list-item-avatar>
                <v-list-item-title>Users</v-list-item-title>
              </v-list-item>
              <!--Devices-->
              <v-list-item
                v-if="access.setup"
                active-color="primary"
                value="devices"
              >
                <v-list-item-avatar left style="position: relative">
                  <v-icon>
                    mdi-cellphone-link
                  </v-icon>
                </v-list-item-avatar>
                <v-list-item-title>Devices</v-list-item-title>
                <v-list-item-action v-if="unassignedDevices">
                  <v-tooltip top>
                    <template v-slot:activator="{on}">
                      <div v-on="on" class="amber--text d-flex align-center caption" @click.stop="gotoPage('devices'); $store.state.ref.devices.tabIndex = 2">
                        <v-icon color="amber" small>mdi-alert-decagram</v-icon>
                      </div>
                    </template>
                    {{unassignedDevices}} Unassigned Devices
                  </v-tooltip>
                </v-list-item-action>
              </v-list-item>
              <!--Employees-->
              <v-list-item
                v-if="access.setup"
                active-color="primary"
                value="employees"
              >
                <v-list-item-avatar left>
                  <v-icon>mdi-account-multiple</v-icon>
                </v-list-item-avatar>
                <v-list-item-title>Employees</v-list-item-title>
              </v-list-item>
              <!--Approvals-->
              <v-list-item
                active-color="primary"
                value="approvals"
                v-if="access.approvals"
              >
                <v-list-item-avatar left style="position: relative">
                  <v-icon>mdi-check-bold</v-icon>
                </v-list-item-avatar>
                <v-list-item-title>Approvals</v-list-item-title>
                <v-list-item-action v-if="approvalsWithAccess.length">
                  <v-tooltip top>
                    <template v-slot:activator="{on}">
                      <div v-on="on" class="amber--text d-flex align-center caption">
                        <v-icon color="amber" small>mdi-alert-decagram</v-icon>
                      </div>
                    </template>
                    {{approvalsWithAccess.length}} Pending Approvals
                  </v-tooltip>
                </v-list-item-action>
              </v-list-item>

              <v-list-item
                v-if="access.leave"
                active-color="primary"
                value="leave"
              >
                <v-list-item-avatar left>
                  <v-icon>mdi-calendar</v-icon>
                </v-list-item-avatar>
                <v-list-item-title>Leave Management</v-list-item-title>
              </v-list-item>
              <!--Teams-->
              <v-list-item
                v-if="access.setup"
                active-color="primary"
                value="teams"
              >
                <v-list-item-avatar left>
                  <v-icon>mdi-account-group</v-icon>
                </v-list-item-avatar>
                <v-list-item-title>Teams</v-list-item-title>
              </v-list-item>
              <!--Classification-->
              <v-list-item
                v-if="access.classification"
                active-color="primary"
                value="classification"
              >
                <v-list-item-avatar left>
                  <v-icon>mdi-apps</v-icon>
                </v-list-item-avatar>
                <v-list-item-title>Classification</v-list-item-title>
              </v-list-item>
              <!--Admin-->
              <v-list-item
                v-if="access.billing"
                active-color="primary"
                value="admin"
              >
                <v-list-item-avatar left>
                  <v-icon>mdi-domain</v-icon>
                </v-list-item-avatar>
                <v-list-item-title>Admin</v-list-item-title>
              </v-list-item>
              <!--Partner-->
              <v-list-item
                v-if="user.masterAdmin || user.partnerId"
                active-color="primary"
                value="partner"
              >
                <v-list-item-avatar left>
                  <v-icon>mdi-handshake</v-icon>
                </v-list-item-avatar>
                <v-list-item-title>Partner Portal</v-list-item-title>
              </v-list-item>

            </v-list-item-group>
          </v-list>


          <div class="pa-2 d-flex justify-center">
            <v-tooltip right :disabled="!mini">
              <template v-slot:activator="{on}">
                <v-btn
                  v-on="on"
                  :small="!mini"
                  :block="!mini"
                  :text="!mini"
                  :icon="mini"
                  color="primary"
                  @click="logOutRun"
                >
                  <v-icon :left="!mini">mdi-logout</v-icon>
                  <template v-if="!mini">
                    Logout
                  </template>
                </v-btn>
              </template>
              Logout
            </v-tooltip>
          </div>

          <div class="pa-2 d-flex justify-center">
            <v-tooltip right :disabled="!mini">
              <template v-slot:activator="{on}">
                <v-btn
                  v-on="on"
                  :small="!mini"
                  :block="!mini"
                  :text="!mini"
                  :icon="mini"
                  color="primary"
                  @click="startDownload"
                  :disabled="downloading"
                  :loading="downloading"
                >
                  <v-icon :left="!mini">mdi-download</v-icon>
                  <template v-if="!mini">
                    Download Installer
                  </template>
                </v-btn>
              </template>
              Download Installer
            </v-tooltip>
          </div>

        </v-navigation-drawer>
        <div class="d-flex flex-column of-y fill-height" style="overflow-x: hidden">
          <app-dlg
            v-if="showSiteSelectDlg"
            :show-dlg.sync="showSiteSelectDlg"
            title="Select Site"
            :default-padding="false"
          >
            <div>

              <v-text-field
                placeholder="Search"
                hide-details
                class="pa-0 ma-0 mx-2"
                color="primary"
                prepend-inner-icon="mdi-magnify"
                outlined
                dense
                v-model="selectSiteFilterStr"
                ref="selectSiteFilterStr"
              ></v-text-field>

              <v-list
                style="max-height: 400px"
                class="of-y"
                dense
              >
                <v-list-item

                  v-for="site in viewSites.filter(obj => !selectSiteFilterStr ? true : ((obj.name || '').toLowerCase().includes((selectSiteFilterStr || '').toLowerCase())))"
                  :key="site._id"
                  @click="showSiteSelectDlg = false; switchSiteRun(site._id)"
                >
                  <v-list-item-title v-text="site.name"/>
                </v-list-item>
              </v-list>
            </div>

            <template v-slot:actions>
              <v-btn
                class="ml-2"
                small
                color="primary"
                @click="showSiteSelectDlg = false"
                outlined
                size="small"
              >
                Cancel
              </v-btn>
            </template>
          </app-dlg>

          <app-nav-bar-body
            ref="navBarBody"
            v-if="loggedIn"
            style="height: 50px"
            @exportDashboardData="exportData"
          />

          <div class="flex-grow-1 of-y" style="overflow-x: hidden">

            <!--                    <v-dialog :value="true">-->
            <!--                        <v-card>Hello</v-card>-->
            <!--                    </v-dialog>-->

            <app-password-reset v-if="showReset"></app-password-reset>
            <template v-else>
              <v-scroll-x-transition hide-on-leave>
                <app-login v-if="!loggedIn && !signup" class="flex-grow-1 of-y"/>
              </v-scroll-x-transition>
              <v-scroll-x-transition hide-on-leave>
                <app-signup v-if="signup" class="flex-grow-1 of-y"></app-signup>
              </v-scroll-x-transition>

              <div v-if="loggedIn && !signup" style="min-height: 100%" class="fill-height">

                <div v-if="startingUp" class="flex-grow-1 d-flex flex-column align-center justify-center ">
                  <v-progress-circular
                    :size="50"
                    color="secondary"
                    indeterminate
                  ></v-progress-circular>
                  <h3 class="pt-4">System Initializing</h3>
                </div>
                <template v-else>

                  <template v-if="false">
                    <div class="caption py-2" v-for="val in devicesWithAccess">
                      {{val.name}}
                    </div>
                  </template>
                  <v-scroll-x-transition hide-on-leave>
                    <app-approvals class="flex-grow-1" v-if="access.approvals && curPage === 'approvals'"/>
                  </v-scroll-x-transition>
                  <v-scroll-x-transition hide-on-leave>
                    <app-users class="flex-grow-1" v-if="access.users && curPage === 'users'"/>
                  </v-scroll-x-transition>
                  <v-scroll-x-transition hide-on-leave>
                    <app-devices class="flex-grow-1" v-if="access.setup && curPage === 'devices'"/>
                  </v-scroll-x-transition>
                  <v-scroll-x-transition hide-on-leave>
                    <app-employees class="flex-grow-1" v-if="access.setup && curPage === 'employees'"/>
                  </v-scroll-x-transition>
                  <v-scroll-x-transition hide-on-leave>
                    <app-teams class="flex-grow-1" v-if="access.setup && curPage === 'teams'"/>
                  </v-scroll-x-transition>
                  <v-scroll-x-transition hide-on-leave>
                    <app-classification class="flex-grow-1" v-if="access.classification && curPage === 'classification'"/>
                  </v-scroll-x-transition>
                  <v-scroll-x-transition hide-on-leave>
                    <app-dashboard :vm="vm" ref="dashboard" class="flex-grow-1" v-if="access.statistics && curPage === 'dashboard'"/>
                  </v-scroll-x-transition>
                  <v-scroll-x-transition hide-on-leave>
                    <app-employee-stats class="flex-grow-1" v-if="access.statistics && curPage === 'employeeStats'"/>
                  </v-scroll-x-transition>
                  <v-scroll-x-transition hide-on-leave>
                    <app-team-stats class="flex-grow-1" v-if="access.statistics && curPage === 'teamStats'"/>
                  </v-scroll-x-transition>
                  <v-scroll-x-transition hide-on-leave>
                    <app-app-stats class="flex-grow-1" v-if="access.statistics && curPage === 'appStats'"/>
                  </v-scroll-x-transition>
                  <v-scroll-x-transition hide-on-leave>
                    <app-admin class="flex-grow-1" v-if="access.billing && curPage === 'admin'"/>
                  </v-scroll-x-transition>
                  <v-scroll-x-transition hide-on-leave>
                    <app-partner class="flex-grow-1" v-if="(user.partnerId || user.masterAdmin) && curPage === 'partner'"/>
                  </v-scroll-x-transition>
                  <v-scroll-x-transition hide-on-leave>
                    <app-leave class="flex-grow-1" v-if="access.leave && curPage === 'leave'"/>
                  </v-scroll-x-transition>
                  <!--                                <v-scroll-x-transition hide-on-leave>-->
                  <!--                                    <app-app-stats class="flex-grow-1" v-if="access.statistics && curPage === 'appStats'"/>-->
                  <!--                                </v-scroll-x-transition>-->
                </template>
              </div>
            </template>
          </div>


        </div>
        <div
          v-if="showDownload"
          style="position: absolute; right: 0; bottom: 0"
          class="pa-2"
        >
          <v-card width="500" class="d-flex align-center">
            <v-progress-circular :size="30" :width="2" :indeterminate="downloadProgress === 0" :value="downloadProgress" color="primary" class="ml-2"></v-progress-circular>
            <div class="flex-grow-1 primary--text px-2 py-2">
              <v-scroll-y-transition hide-on-leave>
                <div v-if="downloadProgress === 0">
                  <div class="subtitle-1 pb-1" style="line-height: 1">Compiling Installer</div>
                  <div class="caption" style="line-height: 1">Please note that this process could take up to 5 minutes</div>
                </div>
              </v-scroll-y-transition>
              <v-scroll-y-transition>
                <div v-if="downloadProgress !== 0">
                  <div class="subtitle-1 pb-1" style="line-height: 1">Downloading Installer<template v-for="n in (new Date().getSeconds() % 5)"> .</template></div>
                  <div class="caption" style="line-height: 1">Download Progress: {{downloadProgress}}%</div>
                </div>
              </v-scroll-y-transition>
            </div>
            <v-tooltip top>
              <template v-slot:activator="{on}">
                <v-btn
                  class="py-0 my-0 mr-2"
                  small
                  icon
                  color="error"
                  v-on="on"
                  @click="showDownload = false"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
              Hide Download
            </v-tooltip>
          </v-card>
        </div>

        <app-dlg
          v-if="loadingEmployeeAppStats"
          :show-dlg.sync="loadingEmployeeAppStats"
          title="Downloading Report"
          :default-padding="false"
        >
          <div class="d-flex align-center justify-center pb-3">
            <v-progress-circular color="primary" indeterminate/>
          </div>
        </app-dlg>
      </template>

      <template v-else>
        <app-employee-dashboard></app-employee-dashboard>
      </template>



    </v-main>
  </v-app>
</template>

<script>

import AppLogin from "@/components/Login/AppLogin";
// import AppSysAdmins from "@/components/SysAdmins/AppSysAdmins";
// import AppClients from "@/components/Clients/AppClients";
import {mapActions, mapGetters} from "vuex";
import AppSnack from "@/components/Shared/Snack/AppSnack";
import AppUsers from "@/components/Users/AppUsers";
import AppNavBarBody from "@/components/Shared/AppNavBarBody/AppNavBarBody";
import AppPasswordReset from "@/components/Login/AppPasswordReset";
import AppDevices from "@/components/Devices/AppDevices";
import AppEmployees from "@/components/Employees/AppEmployees";
import AppTeams from "@/components/Teams/AppTeams";
import AppClassification from "@/components/Classification/AppClassification";
import AppDashboard from "@/components/Dashboard/AppDashboard";
import AppEmployeeStats from "@/components/EmployeeStats/AppEmployeeStats";
import AppTeamStats from "@/components/TeamStats/AppTeamStats";
import AppAppStats from "@/components/AppStats/AppAppStats";
import {initializeSite, newReq, setWindow} from "@/core/request";
import AppSignup from "@/components/Signup/AppSignup";
import AppUserOptions from "@/components/UserOptions/AppUserOptions";
import {arrSplice, exportStats, nameSort} from "@/core/codeFunctions";
import {getConnectionStatus, switchSite} from "@/core/realtimeSync";
import AppCentreLoader from "@/components/Shared/AppCentreLoader";
import AppAdminCompanyInformation from "@/components/Admin/AppAdminCompanyInformation";
import AppAdmin from "@/components/Admin/AppAdmin";
import AppApprovals from "@/components/Approvals/AppApprovals.vue";
import AppPartner from "@/components/Partner/AppPartner";
import AppDlg from "@/components/Shared/AppDlg";
import {format, isSameDay, isSameMonth, isSameYear} from "date-fns";
import AppEmployeeDashboard from "@/components/EmployeeDashboard/AppEmployeeDashboard.vue";
import AppLeave from "@/components/Leave/AppLeave.vue";

// import AppNavBarBody from "@/components/General/AppNavBarBody/AppNavBarBody";

function getUrlParams(url) {
  const urlObj = new URL(url);
  const params = new URLSearchParams(urlObj.search);
  let result = {};

  for(let [key, value] of params) {
    result[key.toLowerCase()] = value;
  }

  return result;
}

export default {
  components: {
    AppLeave,
    AppEmployeeDashboard,
    AppDlg,
    AppPartner,
    AppAdmin,
    AppAdminCompanyInformation,
    AppCentreLoader,
    AppUserOptions,
    AppSignup,
    AppTeamStats,
    AppDashboard,
    AppClassification,
    AppTeams,
    AppDevices,
    AppPasswordReset,
    AppNavBarBody,
    AppSnack,
    AppLogin,
    AppUsers,
    AppEmployees,
    AppEmployeeStats,
    AppAppStats,
    AppApprovals
  },
  data: () => ({
    socketConnected: true,
    drawer: true,
    mini: false,
    startingUp: false,
    showReset: (() => {
      return !!(new URL(window.location)).searchParams.get("link") && !!(new URL(window.location)).searchParams.get("user");
    })(),
    showDownload: false,
    downloadProgress: 0,
    downloading: false,
    console,
    showSiteSelectDlg: false,
    selectSiteFilterStr: null,
    loadingEmployeeAppStats: false
  }),
  created() {
    setWindow(window)

    setInterval(() => {
      this.$store.state.curTime = new Date();
    }, 5000)

    const params = getUrlParams(window.location.href)
    if (params.d && params.siteid && params.hwid) {
      this.$store.state.employeeDashboard.show = true
      this.$store.state.employeeDashboard.hwId = params.hwid
      this.$store.state.employeeDashboard.siteId = params.siteid
    }
  },

  mounted() {
    this.mini = this.smallBar
    // const urlParams = new URLSearchParams(window.location.search);
    // console.log(window.location)
    if ((new URL(window.location)).searchParams.get("signup")) {
      this.$store.state.signup = true
    }

    const vm = this
    this.$store.state.storeEvents.on('denied', () => {
      setTimeout(() => {
        vm.$snack.error('Access Denied')
      }, 300)
    })


    this.checkSocketStatus()
  },
  watch: {
    loggedIn: {
      immediate: true,
      handler(val) {
        if (val) {
          this.startup()
          if (this.live)
            window.addEventListener('beforeunload', function (e) {
              e.preventDefault();
              e.returnValue = '';
            });
        }
      },
    },
    "$store.state.sortPreference": {
      deep: true,
      handler(val) {
        this.updateSortPref()
      }
    },
    showSiteSelectDlg(val) {
      this.selectSiteFilterStr = null

      if (val)
        setTimeout(() => {
          this.$refs.selectSiteFilterStr.focus();
        }, 500)
    },
  },
  methods: {
    ...mapActions(["upsert", "gotoPage"]),

    async getEmployeeAppStats() {
      try {
        this.loadingEmployeeAppStats = true;
        const stats = await this.$newReq('POST', 'dashboard/getAppStatsPerEmployee', {
          start: this.start,
          end: this.end,
        })

        const headers = [
          {text: 'App', value: 'match', description: 'Employee name'},
          {text: 'Employee', value: 'employeeName', description: 'Employee name'},
          {text: 'Label', value: 'label', description: 'Employee name'},
          {text: 'Duration (Hours)', value: 'durationHours', description: 'Duration'},
        ]

        const dateTitle = (() => {
          if (!isSameYear(this.$store.state.ref.dashboard.selectedRange.start, this.$store.state.ref.dashboard.selectedRange.end))
            return `${format(this.$store.state.ref.dashboard.selectedRange.start,'dd MMM yyyy')} - ${format(this.$store.state.ref.dashboard.selectedRange.end,'dd MMM yyyy')}`
          if (!isSameMonth(this.$store.state.ref.dashboard.selectedRange.start, this.$store.state.ref.dashboard.selectedRange.end))
            return `${format(this.$store.state.ref.dashboard.selectedRange.start,'dd MMM')} - ${format(this.$store.state.ref.dashboard.selectedRange.end,'dd MMM yyyy')}`
          if (!isSameDay(this.$store.state.ref.dashboard.selectedRange.start, this.$store.state.ref.dashboard.selectedRange.end))
            return `${format(this.$store.state.ref.dashboard.selectedRange.start,'dd')} - ${format(this.$store.state.ref.dashboard.selectedRange.end,'dd MMM yyyy')}`
          return format(this.$store.state.ref.dashboard.selectedRange.end,'dd MMM yyyy')
        })()

        exportStats(
          `Tracklogix App Usage Per Employee ${dateTitle}`,
          'Apps', headers,
          stats.map(row => {
            row.durationHours = +((row.duration / 3600).toFixed(2))
            return row
          }),
          this.$store.getters.labelsRef
        )

        // {
        //     "_id": {
        //     "empId": "63047519ccc9830a60c3a635",
        //     "match": "app.tasklogix.co.za",
        //     "match": "app.tasklogix.co.za",
        //     "employeeName": "Irene Purchase1",
        //     "duration": 2393.5
        // }

      } catch (e) {
        this.$snack.netWorkError();
        console.log(e)
      } finally {
        this.loadingEmployeeAppStats = false
      }
    },

    async exportData() {

      if (this.$store.state.ref.dashboard.tabIndex === 3) {
        const res = await this.$showPrompt(
          this,
          "Export App Results",
          `How would you like to export app results`,
          [
            {text: "Per App", normal: true},
            {text: "Per App/Employee", normal: true},
          ]
        )

        if (res === "Per App")
          return this.$refs.dashboard.$refs[this.$store.state.ref.dashboard.tabIndex].exportData()
        else if (res === "Per App/Employee") {
          this.getEmployeeAppStats()
        }
      } else {

        const res = await this.$showPrompt(
          this,
          `Export ${this.$store.state.ref.dashboard.tabIndex === 1 ? 'Teams' : 'Employees'} Results`,
          `What kind of export would you like?`,
          [
            {text: "Detail", normal: true},
            {text: "Summary", normal: true},
          ]
        )

        if (res === "Summary")
          this.$refs.dashboard.$refs[this.$store.state.ref.dashboard.tabIndex].exportData()
        else if (res === "Detail")
          this.$refs.dashboard.$refs[this.$store.state.ref.dashboard.tabIndex].exportDataDetail()

      }
    },

    updateSortPref() {
      this.$newReq('POST', 'users/sortPreference', this.$store.state.sortPreference)
        .catch(e => {
          console.log('Error Updating Sort Preference', e)
        })
    },

    checkSocketStatus(timeout = 1000) {

      let count = 0

      setInterval(() => {
        const stat = getConnectionStatus();
        if (stat) {
          this.socketConnected = stat;
          count = 0;
        } else {
          count = ++count
        }
        if (!stat && count >= 5)
          this.socketConnected = stat
      }, 1000)


      // setTimeout(() => {
      //     const stat = getConnectionStatus();
      //     this.socketConnected = stat
      //     if (!stat && this.loggedIn)
      //         this.checkSocketStatus(100)
      //     else
      //         this.checkSocketStatus(1000)
      // }, timeout)
    },

    switchSiteRun(newSite) {
      this.$store.state.curSiteId = newSite;
      initializeSite(newSite);
      arrSplice(this.$store.state.users, () => true);
      arrSplice(this.$store.state.devices, () => true);
      arrSplice(this.$store.state.teams, () => true);
      arrSplice(this.$store.state.employees, () => true);
      arrSplice(this.$store.state.statusmaps, () => true);
      arrSplice(this.$store.state.usersiteprefs, () => true);
      arrSplice(this.$store.state.backPages, () => true);
      this.$store.state.ref.app.curPage =  'dashboard';
      this.$store.state.ref.users.selected =  null;
      this.$store.state.ref.users.filterStr =  null;
      this.$store.state.ref.users.showAdd =  false;
      this.$store.state.ref.users.tabIndex =  0;
      this.$store.state.ref.devices.selected =  null;
      this.$store.state.ref.devices.filterStr =  null;
      this.$store.state.ref.devices.tabIndex =  0;
      this.$store.state.ref.employees.tabIndex =  0;
      this.$store.state.ref.employees.selected =  null;
      this.$store.state.ref.employees.filterStr =  null;
      this.$store.state.ref.employees.showAdd =  false;
      this.$store.state.ref.teams.selected =  null;
      this.$store.state.ref.teams.filterStr =  null;
      this.$store.state.ref.teams.showAdd =  false;
      this.$store.state.ref.classification.selected =  null;
      this.$store.state.ref.classification.filterStr =  null;
      this.$store.state.ref.classification.showAdd =  false;
      this.$store.state.ref.classification.tabIndex =  0;
      this.$store.state.ref.classification.openOnStartup =  null;
      this.$store.state.ref.dashboard.tabIndex =  0;
      this.$store.state.ref.dashboard.filterStr =  null;
      this.$store.state.ref.dashboard.selectedRange.title =  'Today';
      this.$store.state.ref.dashboard.showColumnSelection =  false;
      this.$store.state.ref.employeeStats.selectedEmployee =  null;
      this.$store.state.ref.employeeStats.showCardsSelection =  false;
      this.$store.state.ref.teamStats.selectedTeam =  null;
      this.$store.state.ref.teamStats.showCardsSelection =  false;
      this.$store.state.ref.appStats.selectedApp =  null;
      this.$store.state.ref.appStats.showCardsSelection =  false;
      this.startup();
    },

    updateDownloadInstallerProgress(progressObj) {
      this.downloadProgress = Math.round((progressObj.loaded / progressObj.total) * 100)
    },
    startDownload() {
      this.showDownload = true;
      this.downloadProgress = 0;
      this.downloading = true;

      this.$newReqDownloadFile(
        'GET',
        `installer`,
        null,
        `Tracklogix ${this.$store.state.curSiteId}.msi`,
        true,
        false,
        this.updateDownloadInstallerProgress
      )
        .catch(e => {
          console.log(e)
          this.$snack.netWorkError();
        })
        .finally(() => {
          this.showDownload = false;
          this.downloadProgress = 0;
          this.downloading = false;
        })
    },

    startup() {
      this.startingUp = true
      this.$newReq('GET', `startup`, null, true)
        .then((data) => {

          if (data.siteConfig) {
            this.$store.dispatch('setSiteConfig', data.siteConfig);
          } else {
            this.$store.dispatch('setSiteConfig', null);
          }
          
          this.$store.state.liveViewEnabled = !!data.liveViewEnabled;

          this.upsert(data);
          this.$vuetify.theme.dark = this.user.theme;

          if (!this.user.sortPreference)
            this.user.sortPreference = JSON.parse(JSON.stringify(this.$store.state.sortPreference))

          Object.assign(this.$store.state.sortPreference, this.user.sortPreference)

          if (!this.user.defaultSelections)
            this.user.defaultSelections = null

          this.$store.state.ref.dashboard.employeesSelectedColumns = this.user.defaultSelections.employeesSelectedColumns || this.$store.state.defaultSelections.employeesSelectedColumns;
          this.$store.state.ref.dashboard.teamsSelectedColumns = this.user.defaultSelections.teamsSelectedColumns || this.$store.state.defaultSelections.teamsSelectedColumns;
          this.$store.state.ref.dashboard.appsSelectedColumns = this.user.defaultSelections.appsSelectedColumns || this.$store.state.defaultSelections.appsSelectedColumns;
          this.$store.state.ref.employeeStats.selectedCards = this.user.defaultSelections.employeeStats || this.$store.state.defaultSelections.employeeStats;
          this.$store.state.ref.teamStats.selectedCards = this.user.defaultSelections.teamStats || this.$store.state.defaultSelections.teamStats;
          this.$store.state.ref.appStats.selectedCards = this.user.defaultSelections.appStats || this.$store.state.defaultSelections.appStats;
        })
        .catch(e => {
          console.log(e)
        })
        .finally(() => {
          this.startingUp = false
        })
    },

    logOutRun() {
      window.location.reload();
    }
  },
  computed: {
    vm() {
      return this
    },
    ...mapGetters(['devices', 'user', 'access', 'live', 'signup', 'site', 'sites', 'approvalsWithAccess']),
    viewSites() {
      return this.sites.filter((site) => !site.disabled && this.user.siteIds.includes(site._id) && !this.user.disabledSiteIds.includes(site._id)).sort(nameSort)
    },


    start() {
      return this.$store.state.ref.dashboard.selectedRange.start
    },
    end() {
      return this.$store.state.ref.dashboard.selectedRange.end
    },

    unassignedDevices() {
      return this.devices
        .filter(device => !device.employeeId && !device.disabled)
        .length
    },

    smallBar() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return true
        case 'sm': return true
        case 'md': return true
        case 'lg': return false
        case 'xl': return false
        default: return false
      }
    },
    ...mapGetters(["loggedIn", "user", "site"]),
    lightTheme: {
      get() {
        return this.$vuetify.theme.dark
      },
      set(val) {
        this.$vuetify.theme.dark = val;
        this.user.theme = val;
        this.user.update();
      }
    },
    curPage: {
      get() {
        return this.$store.state.ref.app.curPage
      },
      set(val) {
        this.gotoPage(val)
      }
    },
    // refVars: {
    //     get() {
    //         return this.$store.state.refVars
    //     },
    //     set(val) {
    //         Object.assign(this.$store.state.refVars, val)
    //     }
    // },
  }
};

//Remove-Item "C:\Users\*\AppData\Local\Programs\Tracklogix" -Force -WhatIf -Recurse
</script>
